import { Grid } from "@mui/material";
import * as React from "react";
import {
  Create,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput,
} from "react-admin";
import { CountryEnum, StateEnum } from "src/common/enum";
import { insertIntoArray } from "src/common/UtilFunctions";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { TaxRatesTitle } from "./TaxRatesTitle";
import Transformer from "src/common/Transformer";

export const TaxRatesCreate = () => {
  const TaxRatesStateEnum = insertIntoArray(StateEnum, 1, {
    id: "*",
    name: "All",
  });

  const transform = (data) => {
    Transformer(data, {
      remove: [],
      update: {
        tax: data.tax.id
      },
    });
    return data;
  };

  return (
    <Create transform={transform} title={<TaxRatesTitle />}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <ReferenceInput source="tax.id" reference="admin/taxes">
              <SelectInput optionText="name" label="Tax" validate={required()} />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} lg={8}>
            <NumberInput source="rate" min={0} validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="zip" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput source="country" choices={CountryEnum} validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput
              source="state"
              choices={TaxRatesStateEnum.slice(1)}
              emptyValue={""}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
